import { RuntimeConfigurationServiceDomain } from '../RuntimeConfigurationService/domain';

/**
 * Namespaced so we don't pollute the global intellisense namespace with a billion generically named constants
 */
export namespace APIConfigurationServiceDomain {
    export type SupportedServices = {
        graphql: string;
        max: string;
        settings: string;
        zillowAuth0: string;
        zillowAuth: string;
        zillowDomain: string;
    };

    export const DEPLOYMENT_ENVIRONMENT_TO_SERVICES: Record<
        RuntimeConfigurationServiceDomain.DeploymentEnvironment,
        SupportedServices
    > = {
        [RuntimeConfigurationServiceDomain.DeploymentEnvironment.LOCAL]: {
            graphql: 'https://zg-graph-stage.int.zgcp-federated-nonprod-k8s.zg-int.net/graphql/',
            max: 'https://mortgageapi.qa.zillow.net',
            settings: 'https://settings.staging.zillowhomeloans.net/api',
            zillowAuth: 'https://authv2.qa.zillow.net',
            zillowAuth0: 'https://identity.qa.zillow.net',
            zillowDomain: 'https://qa.zillow.net',
        },
        [RuntimeConfigurationServiceDomain.DeploymentEnvironment.DEVELOPMENT]: {
            graphql: 'https://zg-graph-dev.int.zgcp-federated-nonprod-k8s.zg-int.net/graphql/',
            max: 'https://mortgageapi.qa.zillow.net',
            settings: 'https://settings.staging.zillowhomeloans.net/api',
            zillowAuth: 'https://authv2.qa.zillow.net',
            zillowAuth0: 'https://identity.qa.zillow.net',
            zillowDomain: 'https://qa.zillow.net',
        },
        [RuntimeConfigurationServiceDomain.DeploymentEnvironment.STAGING]: {
            graphql: 'https://zg-graph-stage.int.zgcp-federated-nonprod-k8s.zg-int.net/graphql/',
            max: 'https://mortgageapi.qa.zillow.net',
            settings: 'https://settings.staging.zillowhomeloans.net/api',
            zillowAuth: 'https://authv2.qa.zillow.net',
            zillowAuth0: 'https://identity.qa.zillow.net',
            zillowDomain: 'https://www.qa.zillow.net',
        },
        [RuntimeConfigurationServiceDomain.DeploymentEnvironment.PRODUCTION]: {
            graphql: 'https://zg-graph-prod.int.zgcp-federated-prod-k8s.zg-int.net/',
            max: 'https://mortgageapi.zillow.com',
            settings: 'https://settings.zillowhomeloans.com/api',
            zillowAuth: 'https://authv2.zillow.com',
            zillowAuth0: 'https://identity.zillow.com',
            zillowDomain: 'https://www.zillow.com',
        },
    };
}
